/** @jsx jsx */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { useState } from 'react';
import Button from '@atlaskit/button/custom-theme-button';
import { ActionIcon } from './ActionIcon';
export const spinnerDelay = 1000;
const baseTextStyles = css({
  transition: 'opacity 0.3s'
});
export const Action = ({
  promise,
  text,
  buttonAppearance = 'default',
  id
}) => {
  const [state, setState] = useState('init');
  return jsx(Button, {
    spacing: "compact",
    appearance: buttonAppearance,
    isLoading: state === 'loading',
    testId: `button-${id}`,
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
      if (state !== 'loading') {
        setState('loading');
        promise().then(() => {
          setState('success');
        }).catch(() => {
          setState('failure');
        }).finally(() => {
          setTimeout(() => setState('init'), spinnerDelay);
        });
      }
    }
  }, jsx("div", {
    css: [baseTextStyles, {
      opacity: state !== 'init' ? 0 : 1
    }]
  }, text), jsx(ActionIcon, {
    state: state
  }));
};